import { ChatbotApiClient } from "api/ChatbotApiClient";
import { useApiClient } from "./useApiClient";
import { config } from '@config'
import { waitUntil } from "shared/utils";

export function useChatConfiguration() {
    const chatbotApiClient = useApiClient(a => new ChatbotApiClient(a))
    // @ts-ignore
    const isChatAvailable = () => typeof _giosg !== "undefined"
    // @ts-ignore
    const isChatHelperAvailable = () => typeof giosg !== "undefined" && typeof giosg.rooms !== "undefined"

    const set = async () => {
        if (config.showChat) {
            await waitUntil(isChatHelperAvailable, "Chat helper did not load within the timeout period");
            await waitUntil(isChatAvailable, "Chat did not load within the timeout period");

            const visitorVariablesPayload = await chatbotApiClient.getChatbotVisitorVariablesPayload()
            // @ts-ignore
            const roomList = giosg.allowedRooms.map(room => ({ "id": room.id }))
            // @ts-ignore
            _giosg('visitor', 'submit', visitorVariablesPayload, 'HS256', true, roomList);
        }
    }

    const clear = () => {
        if (config.showChat && isChatHelperAvailable()) {
            // @ts-ignore
            const chatbutton = document.querySelector(".wp-exclude-emoji");
            if(chatbutton) {
                chatbutton.remove()
            }
            // @ts-ignore
            giosg.allowedRooms.map(r => ({ "id": r.id, clearHistory: true, hide: true })).forEach(room => {
                // @ts-ignore
                giosg.api.visitor.removeAll({ id: room.id }).then(() => {
                    // @ts-ignore
                    _giosg('chat', 'close', room);
                })
            });
        }
    }

    return {
        set,
        clear
    }
}